export const HIDE_MODAL_ANIMATION_TIME = 150;
